<template>
  <div class="detail">
    <div class="notice">
      <van-notice-bar left-icon="volume-o" background="#FFE7C2" color="#FF3A3A" :scrollable="false">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item,index) in spikeRolling" :key="index">
            {{`刚刚${item}`}}
          </van-swipe-item>
        </van-swipe>
      </van-notice-bar>
    </div>
    <div class="top-img-box">
      <img :src="goods.headImg" mode="widthFix" alt="" />
    </div>
    <div class="tab">
      <div class="tab-left">
        <div class="title">{{goods.goodsName}}</div>
        <div class="bottom">
          <div class="bottom-left">
            <span class="rmb">￥</span>
            <span class="rmb">{{goods.groupBuyPrice}}</span>
          </div>
          <div class="bottom-right">
            <span v-if="goods.oldPrice > 0">价格: {{goods.oldPrice}}</span>
            <span v-else>免费</span>
            <div class="min-bottom">
              <div class="bottom" v-if="goods.goodsTag">{{goods.goodsTag}}</div>
              <div class="bottom">{{goods.teamNumber}}人团</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-right">
        <div class="right-top">
          <div class="pin">拼</div>
          <p>已有<span>200人</span>参与拼图</p>
        </div>
        <div class="right-bottom">库存：{{goods.goodsNumber}}</div>
      </div>
    </div>
    <div class="card"  v-if="false">
      <div class="title-box">
        <div class="line"></div>
          <div class="text">
            <span>11人</span>
            正在参团  可直接参与</div>
        <div class="line"></div>
      </div>
    </div>
    <!-- <div class="card open" v-if="false">
      <div class="title-box">
        <div class="line"></div>
        <div class="text">刚刚这些人开团成功  快来开团吧</div>
        <div class="line"></div>
      </div>
      <div class="head-box">
        <div class="item" v-for="item in 4" :key="item">
          <div class="head"></div>
          <span>啦啦</span>
        </div>
      </div>
      <div class="bottom">立即开团</div>
    </div> -->
    <div class="card">
      <div class="title-box">
        <div class="line"></div>
        <div class="text">还没人来团 快来开团吧</div>
        <div class="line"></div>
      </div>
      <div class="bottom">我要开团</div>
    </div>
    <div class="detail-img">
      <template v-if="goods.goodsDetails && goods.goodsDetails.length">
        <img :src="img" mode="widthFix" v-for="(img,index) in goods.goodsDetails" :key="index"/>
      </template>
      <img  v-else src="https://img3.quanyou.com.cn/joy/group1/M00/19/20/rB4ChmNaMZSAfoLXAAGUF_1MjUY048.png" mode="widthFix"/>
    </div>
    <div style="height: 82px;"></div>
    <div class="footer">
      <div class="botton">单独购买</div>
      <div class="botton right">我要开团</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spikeRolling: ['ccc'],
    }
  },
  computed: {
    goods() {
      return this.$route.query
    }
  },
  methods: {
  
  },
  mounted() {
  }
}
</script>

<style lang="stylus" scoped>
  .detail {
    background: #e1e1e1;
    .notice {
      .van-notice-bar {
        height: 32px;
      }
    }
    .top-img-box {
      height: 100%;
      overflow: hidden;
      font-size: 0;
      img {
        width: 100%;
        height: auto;
      }
    }
    .tab {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 77px;
      background: url('https://img3.quanyou.com.cn/joy/group1/M00/19/F4/rB4ChWNrDI-AXr1PAAB0NQ8HnOs404.png');
      background-size: 100% 100%;
      position: relative;
      top: -22px;
      .tab-left {
        padding: 10px 0 10px 10px
        width: 202px;
        .title {
          font-size: 12px;
          color: #FFFFFF;
        }
        .bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .bottom-left {
            font-size: 22px;
            color: #fff;
            font-weight: bold;
            flex: 1;
            margin-top: 8px;
          }
          .bottom-right {
            span {
              font-size: 9px;
              color: #fff;
              font-weight: bold;
              text-decoration: line-through;
            }
            .min-bottom {
              display: flex;
              margin-top: 4px;
              .bottom {
                padding: 2px 3px;
                background: #FFD648;
                border-radius: 4px;
                color: #F02526;
                font-size: 8px;
              }
              .bottom:last-child {
                margin-left: 3px;
              }
            }
          }
        }
      }
      .tab-right {
        margin: 24px 8px 0 0;
        .right-top {
          display: flex;
          align-items: center;
          .pin {
            padding: 1px 2px;
            background: #FFD648;
            border-radius: 2px;
            color: #F95127;
            font-size: 7px;
            margin-right: 4px;
          }
          p {
            font-size: 10px;
            color: #fff;
            span {
              color: #FFD648;
              font-weight: bold;
            }
          }
        }
        .right-bottom {
          font-size: 7px;
          color: #fff;
          text-align: right;
          // margin-top: 5px;
        }
       
      }
    }
    .card {
      width: 100%;
      overflow hidden
      margin-top: -16px;
      background: #FFFFFF;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 8px 35px 8px 37px;
      .title-box {
        display: flex;
        align-items: center;
        margin-top: 18px;
        margin-bottom: 15px;
        .line {
          flex: 1
          height: 1px;
          background: #B5B5B5;
        }
        .text {
          font-size: 13px;
          color: #464441;
          font-weight: bold;
          margin: 0 16px;
          span {
            color: #ED1925;
          }
        }
      }
      .bottom {
        width: 181px;
        height: 44px;
        background: linear-gradient(0deg, #F12B26 0%, #FD6827 100%);
        box-shadow: 0px 2px 4px 0px rgba(214,94,22,0.4);
        border-radius: 22px;
        color: #FFFFFF;
        font-size: 19px;
        font-weight: bold;
        text-align: center;
        line-height: 44px;
        margin: 26px auto;
      }
    }
    .open {
      padding: 0;
      padding-bottom: 5px;
      .title-box {
        width: 100%;
        height: 50px;
        margin-top: 0;
        box-sizing: border-box;
        padding: 0 22px;
        background: #FFF2EB;
        opacity: 0.57;
        border-radius: 10px 10px 0px 0px;
        .line {
          background: #F02925;
        }
        .text {
          color: #F02925;
        }
      }
      .head-box {
        display: flex;
        justify-content: center;
        margin-top: 25px;
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 22px;
          .head {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            background: #ccc;
          }
          span {
            color: #464441;
            font-size: 12px;
            margin-top: 7px;
          }
        }
        .item:last-child {
          margin-right: 0;
        }
      }
    }
    .detail-img {
      margin-top: 6px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      height: 100%;
      overflow: hidden;
      font-size: 0;
      img {
        width: 100%;
        height: auto;
      }
    }
    .footer {
      position: fixed;
      bottom: 0;
      right: 0;
      left: 0;
      display: flex;
      justify-content: space-around;
      height: 82px;
      background: #FFFFFF;
      box-shadow: -1px -7px 18px 1px rgba(96,96,96,0.34);
      .botton {
        width: 154px;
        height: 40px;
        background: #FFE0CE;
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        color: #F84B27;
        font-size: 16px
        font-weight: bold;
        margin-top: 14px;
      }
      .right {
        color: #FFFFFF;
        background: linear-gradient(94deg, #FE6D28 0%, #EC1825 100%);
      }
    }
  }
</style>